import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appConvertArabicNumbers]'
})
export class ConvertArabicNumbersDirective {

  private easternToWesternMap: Record<string,string> = {
    '٠':'0','١':'1','٢':'2','٣':'3','٤':'4',
    '٥':'5','٦':'6','٧':'7','٨':'8','٩':'9'
  };

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    const converted = this.convertArabicToEnglish(value);
    if (converted !== value) {
      this.el.nativeElement.value = converted;
      this.el.nativeElement.dispatchEvent(new Event('input'));
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();

    const pasted = event.clipboardData?.getData('text') ?? '';
    const converted = this.convertArabicToEnglish(pasted);

    const input = this.el.nativeElement;
    const start = input.selectionStart ?? 0;
    const end   = input.selectionEnd   ?? 0;
    const old   = input.value;

    const newValue = old.slice(0, start) + converted + old.slice(end);

    input.value = newValue;
    input.dispatchEvent(new Event('input'));

    const pos = start + converted.length;
    setTimeout(() => {
      input.setSelectionRange(pos, pos);
    }, 0);
  }

  private convertArabicToEnglish(str: string): string {
    return str.replace(/[٠-٩]/g, d => this.easternToWesternMap[d] || d);
  }
}
